import { render, staticRenderFns } from "./VPrescriptionDrawingUpload.vue?vue&type=template&id=c60f3822&"
import script from "./VPrescriptionDrawingUpload.vue?vue&type=script&lang=ts&"
export * from "./VPrescriptionDrawingUpload.vue?vue&type=script&lang=ts&"
import style0 from "./VPrescriptionDrawingUpload.vue?vue&type=style&index=0&id=c60f3822&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports